module.exports = __webpack_public_path__ + "static/media/topbanner.f95bd919.png";